export default function isTagsColliding(required: string[], banned: string[]) {
  return required.some((req: string) => banned.includes(req))
}
